import { render, staticRenderFns } from "./KategoriMobile.vue?vue&type=template&id=756cd12f&scoped=true"
import script from "./KategoriMobile.vue?vue&type=script&lang=js"
export * from "./KategoriMobile.vue?vue&type=script&lang=js"
import style0 from "./KategoriMobile.vue?vue&type=style&index=0&id=756cd12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756cd12f",
  null
  
)

export default component.exports